import { Component } from "@angular/core";

@Component({
    selector: "la-home",
    templateUrl: "./home.component.html",
    styleUrls: ["./home.component.scss"],
    standalone: true,
})
export class HomeComponent {}
